import { Close } from 'components/lib/icons'
import NakedButton from 'components/lib/NakedButton'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ATTACHMENT_STATES } from 'types/attachments'

export default function FileAttachmentErrorBanner({
  attachmentState,
  clearFiles,
  disabled,
  reset
}) {
  const ref = useRef<HTMLSpanElement>(null)
  const { t } = useTranslation()

  useEffect(() => {
    if (ref.current) {
      ref.current.focus()
    }
  }, [ref])

  const handleOnClick = () => {
    reset()
    clearFiles()
  }

  return (
    <div
      className="drift-widget-attachment-send-status drift-widget-attachment-send-status--failed"
    >
      <span
        ref={ref}
        tabIndex={-1}
        aria-live="assertive"
        className="drift-widget-attachment-send-status--text"
      >
        {t(attachmentState === ATTACHMENT_STATES.SIZE_ERROR ?
          'attachment.errorSize' :
          'attachment.error'
        )}
      </span>
      <NakedButton
        aria-label="Close file attachment error banner"
        onClick={handleOnClick}
        className="drift-widget-attachment-send-status--close"
        disabled={disabled}
      >
        <Close width={10} height={10} />
      </NakedButton>
    </div>
  )
}
